import React from 'react';

const CardReceitasOrigemCanal = ({ data }) => {
  if (!data || !data.canais || data.canais.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
        Nenhum dado disponível
      </div>
    );
  }

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  const getCanalIcon = (canal) => {
    const icons = {
      'Presencial': '🏪',
      'Marketplace': '🛒',
      'Licitação Pública': '📋',
      'Não Informado': '❓'
    };
    return icons[canal] || '📊';
  };

  const getCanalColor = (index) => {
    const cores = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6'];
    return cores[index % cores.length];
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* Resumo Geral */}
      <div style={{ 
        marginBottom: '20px', 
        padding: '15px', 
        backgroundColor: '#f0f9ff', 
        borderRadius: '8px',
        border: '2px solid #bae6fd'
      }}>
        <div style={{ fontSize: '14px', color: '#0c4a6e', fontWeight: '600' }}>
          📊 Resumo Geral
        </div>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(3, 1fr)', 
          gap: '10px', 
          marginTop: '10px' 
        }}>
          <div>
            <div style={{ fontSize: '11px', color: '#0c4a6e' }}>Receita Total</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#0c4a6e' }}>
              {formatarMoeda(data.resumo.total_receita)}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '11px', color: '#0c4a6e' }}>Total OS</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#0c4a6e' }}>
              {data.resumo.total_os}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '11px', color: '#0c4a6e' }}>Canal Líder</div>
            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#0c4a6e' }}>
              {getCanalIcon(data.resumo.canal_mais_lucrativo)} {data.resumo.canal_mais_lucrativo}
            </div>
          </div>
        </div>
      </div>

      {/* Lista de Canais */}
      {data.canais.map((canal, index) => (
        <div 
          key={index}
          style={{ 
            marginBottom: '15px', 
            padding: '15px', 
            backgroundColor: '#ffffff', 
            borderRadius: '8px',
            border: `2px solid ${getCanalColor(index)}`,
            position: 'relative'
          }}
        >
          {/* Cabeçalho */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '10px'
          }}>
            <div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#374151' }}>
                {getCanalIcon(canal.canal)} {canal.canal}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {canal.quantidade_os} OS faturadas
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: getCanalColor(index) 
              }}>
                {formatarMoeda(canal.receita_total)}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280' }}>
                {canal.percentual_receita}% do total
              </div>
            </div>
          </div>

          {/* Barra de Progresso */}
          <div style={{ 
            marginBottom: '10px', 
            backgroundColor: '#e5e7eb', 
            borderRadius: '4px', 
            height: '8px' 
          }}>
            <div style={{ 
              width: `${canal.percentual_receita}%`, 
              backgroundColor: getCanalColor(index),
              height: '100%',
              borderRadius: '4px',
              transition: 'width 0.3s'
            }}></div>
          </div>

          {/* Métricas */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(2, 1fr)', 
            gap: '10px',
            fontSize: '12px',
            color: '#6b7280'
          }}>
            <div>
              <span style={{ fontWeight: '600' }}>Lucro:</span> {formatarMoeda(canal.lucro_total)}
            </div>
            <div>
              <span style={{ fontWeight: '600' }}>Margem:</span> {canal.margem_lucro}%
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardReceitasOrigemCanal;